import { useState } from "react";
import { Link } from "react-router-dom";
import PrivacyModal from "./PrivacyModal";
import BrandLogo from "./BrandLogo";
import { footerCategories, INSTAGRAM_URL, VELLORA_URL, WHATSAPP_URL } from "@/mocks/navigation";
import { useSiteText } from "@/lib/siteContent";

export default function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const signature = useSiteText("footer.signature", "Passos que acompanham cada versão de você.");
  const note = useSiteText("footer.note", "Modelo demonstrativo criado pela Vellora Studio.");

  return (
    <footer className="w-full bg-foreground-950 text-background-100">
      <div className="px-4 py-14 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
          <div className="lg:col-span-1">
            <BrandLogo tone="light" size="lg" />
            <p className="mt-4 max-w-xs font-heading text-xl italic text-accent-300">
              {signature}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Categorias</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {footerCategories.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="cursor-pointer whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Atendimento</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-200">
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-whatsapp-line text-base text-accent-400" />
                </span>
                <a
                  href={WHATSAPP_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
                >
                  WhatsApp — falar com a Auréa
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-instagram-line text-base text-accent-400" />
                </span>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cursor-pointer whitespace-nowrap transition-colors hover:text-accent-300"
                >
                  @vellora__studio
                </a>
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-5 w-5 items-center justify-center pt-0.5">
                  <i className="ri-computer-line text-base text-accent-400" />
                </span>
                <span>Atendimento digital em todo o Brasil</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-xl text-background-50">Fale com a gente</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              Escolha seus calçados e acessórios com calma e finalize tudo pelo WhatsApp, com
              atendimento próximo e humano.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-whatsapp-line text-base" />
              Falar no WhatsApp
            </a>
            <Link
              to="/"
              className="mt-3 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm text-background-200 transition-colors hover:text-accent-300"
            >
              <i className="ri-arrow-up-line text-base" />
              Voltar ao início
            </Link>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-foreground-800 bg-foreground-900/50 p-5 md:p-6">
          <p className="flex items-start gap-3 text-sm text-background-100">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center pt-0.5">
              <i className="ri-information-line text-base text-accent-400" />
            </span>
            <span>
              <strong className="font-medium text-background-50">{note}</strong>{" "}
              A Auréa é um piloto comercial demonstrativo de loja de calçados femininos e acessórios.
              Não representa uma loja em funcionamento e não possui dados legais, endereço ou meios de
              pagamento definidos.
            </span>
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 border-t border-foreground-800 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} Auréa — modelo demonstrativo. Todos os direitos reservados.
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <button
              type="button"
              onClick={() => setPrivacyOpen(true)}
              className="cursor-pointer whitespace-nowrap text-xs text-background-200 transition-colors hover:text-accent-300"
            >
              Política de privacidade
            </button>
            <Link
              to="/painel"
              className="cursor-pointer whitespace-nowrap text-xs text-background-300 transition-colors hover:text-accent-300"
            >
              Acessar painel demonstrativo
            </Link>
            <a
              href={VELLORA_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer whitespace-nowrap text-xs text-accent-300 transition-colors hover:text-accent-300"
            >
              Desenvolvido pela Vellora Studio
            </a>
          </div>
        </div>
      </div>

      <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </footer>
  );
}